<script>
  import { fp } from "./stores/fingerprint.js";
  import { push, replace, pop } from "svelte-spa-router";
  import { getRandomColor } from "./utils.js";
  import { onMount, onDestroy } from "svelte";
  import { newStation } from "./firebase.js";
  import InfoPopup from "./InfoPopup.svelte";
  import { fade } from "svelte/transition";
  import { querystring } from "svelte-spa-router";

  let joinId;
  let showInfo = false;
  let us_querrystring;

  onMount(async () => {
    if ($querystring.includes("showInfo=true")) {
      replace("/");
      await new Promise((resolve) => setTimeout(resolve, 100));
      push("/?showInfo=true");
    }

    us_querrystring = querystring.subscribe((str) => {
      if (str.includes("showInfo=true")) {
        showInfo = true;
      } else {
        showInfo = false;
      }
    });
  });

  onDestroy(() => {
    us_querrystring();
  });

  function joinStation() {
    push(`/${joinId.toUpperCase()}`);
  }

  function catchClick(e) {
    e.stopPropagation();
  }

  function catchEnter(e) {
    if (e.code === "Enter") joinStation();
  }
</script>

<div class="home">
  <div class="logo" />
  <div class="buttons">
    <div
      class="button"
      on:click={async () => {
        const newStationId = await newStation();
        push(`/${newStationId.toUpperCase()}`);
      }}
      on:keydown={{}}
    >
      <span>New Station</span>
    </div>
    <div class="button" on:click={joinStation} on:keydown={{}}>
      <span>Join Station</span>
      <input
        maxlength="4"
        bind:value={joinId}
        on:click={catchClick}
        on:keydown={catchEnter}
      />
    </div>
  </div>
  <p
    on:keydown={{}}
    on:click={() => {
      push("/?showInfo=true");
    }}
    class="absolute infoOnHover bottom-6 text-4xl text-white"
  >
    <i class="fa-regular fa-circle-question"></i>
  </p>
  {#if showInfo}
    <div class="fixed size-full z-20" transition:fade={{ duration: 300 }}>
      <InfoPopup on:close={pop} />
    </div>
  {/if}
</div>

<style>
  .home {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
  }
  .buttons {
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 80vw;
    width: 360px;
    margin-top: 32px;
  }

  .button {
    width: 100%;
    height: 78px;
    background: #ffffff05;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    color: #fff;
    font-size: 18px;
    font-family: "Dosis";
    font-family: "Catamaran";
    font-family: "Luckiest Guy";
    font-family: "Paytone One";
    text-align: left;
    padding: 5px;
    border: 4px solid white;
    border-radius: 120px;
    cursor: pointer;
    gap: 12px;
  }

  .button:hover {
    background: #ffffff30;
  }

  .infoOnHover:hover {
    background: #ffffff30;
    border-radius: 100%;
    line-height: 34px;
  }

  input {
    text-transform: uppercase;
    margin: 0;
    border-radius: 5px;
    border: 1px solid #e9e9e9;
    padding: 3px;
    text-align: center;
    color: #585858;
    font-size: 20px;
    letter-spacing: 5px;
    width: calc(4ch + 60px);
  }

  input:focus {
    outline: none;
  }

  .logo {
    background-image: url(/images/logo.png);
    width: 240px;
    aspect-ratio: 1.345514950166113;
    background-size: contain;
    background-repeat: no-repeat;
    margin-bottom: 20px;
    max-width: 50%;
    min-width: 120px;
  }

  @media (max-width: 435px) {
    .button {
      height: 68px;
      width: 90%;
      min-width: 180px;
    }

    input {
      font-size: 14px;
    }
  }

  @media (max-width: 390px) {
    .button {
      font-size: 14px;
    }
  }
</style>
